import MegaMenu from "./MegaMenu";
import MobileMenu from "./MobileMenu";

function Header() {
  this.mainHeader = document.querySelector("header.main-header");
  this.searchWrapper = document.querySelector(".main-header .search-wrapper");
  this.searchButtons = this.mainHeader.querySelectorAll(".btn-search");
  this.scrollHeader = this.mainHeader.querySelector(".mobile-header-scroll");
  this.hamburger = this.mainHeader.querySelector(".btn-hamburger");
  this.cookieBar = document.getElementById("site-cookie-bar");
  this.page = document.getElementById("page");
  this.resizeTimeout = null;

  this.all = [
    ...this.mainHeader.querySelectorAll(".mega-menu-wrapper"),
    ...this.searchButtons,
    this.searchWrapper,
    this.mainHeader.querySelector(".main-header__nav-mobile--wrapper"),
  ];

  this.setHeaderColor = () => {
    const hero =
      document.querySelector(".acf-block--hero") ||
      document.querySelector('[class*="block-hero"]');
    if (hero) {
      if (hero.classList.contains("bg-dark")) {
        this.mainHeader.classList.add("bg-dark");
      } else if (hero.classList.contains("bg-primary-purple")) {
        this.mainHeader.classList.add("bg-primary-purple");
      } else if (hero.classList.contains("bg-heavier-purple")) {
        this.mainHeader.classList.add("bg-heavier-purple");
      } else if (hero.classList.contains("bg-neutral-11")) {
        this.mainHeader.classList.add("bg-neutral-11");
      } else {
        this.mainHeader.classList.add("bg-white");
      }

      if (hero.classList.contains("is-style-transparent-header")) {
        this.mainHeader.classList.add("bg-transparent-header");
      }
    } else {
      this.mainHeader.classList.add("bg-white");
    }

    if (this.mainHeader.classList.contains("bg-initial")) {
      this.mainHeader.classList.remove("bg-initial");
    }
  };

  this.setGlobals = () => {
    const headerHeight = this.mainHeader.getBoundingClientRect().height;
    const windowHeight = window.innerHeight;
    let alertHeight = 0;
    if (document.getElementById("e29-alert-bar")) {
      alertHeight = document
        .getElementById("e29-alert-bar")
        .getBoundingClientRect().height;
    }
    document.body.style.setProperty("--header-height", `${headerHeight}px`);
    document.body.style.setProperty("--window-height", `${windowHeight}px`);
    document.body.style.setProperty("--alert-height", `${alertHeight}px`);
  };

  this.closeAll = (menus) => {
    menus.forEach((menu) => {
      if (menu.previousElementSibling) {
        menu.previousElementSibling.classList.remove("active");
      }
      menu.classList.remove("active");
      this.hamburger.classList.remove("sub-open");
      document.body.classList.remove("lock-scroll");
      if (!this.checkPagePosition()) {
        this.mainHeader.classList.remove("bg-overwhite");
      }
    });
  };

  this.headerReady = () => {
    const headerReadyTimeout = setTimeout(() => {
      if (matchMedia("(min-width: 1200px)").matches) {
        document.body.classList.add("header-ready");
      } else {
        document.body.classList.add("mobile-header-ready");
      }
      clearTimeout(headerReadyTimeout);
    }, 600);
  };

  this.preventMenusOnResize = () => {
    if (document.body.classList.contains("lock-scroll")) {
      if (matchMedia("(min-width: 1200px)").matches) {
        if (!document.body.classList.contains("header-ready")) {
          this.closeAll(this.all);
        }
        document.body.classList.remove("mobile-header-ready");
        const desktopTimeout = setTimeout(() => {
          document.body.classList.add("header-ready");
          clearTimeout(desktopTimeout);
        }, 600);
      } else {
        if (!document.body.classList.contains("mobile-header-ready")) {
          this.closeAll(this.all);
        }
        document.body.classList.remove("header-ready");
        const mobileTimeout = setTimeout(() => {
          document.body.classList.add("mobile-header-ready");
          clearTimeout(mobileTimeout);
        }, 600);
      }
      return;
    }

    document.body.classList.remove("header-ready", "mobile-header-ready");

    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    this.resizeTimeout = setTimeout(() => {
      clearTimeout(this.resizeTimeout);
      if (matchMedia("(min-width: 1200px)").matches) {
        document.body.classList.add("header-ready");
      } else {
        document.body.classList.add("mobile-header-ready");
      }
    }, 600);
  };

  this.toggleMenu = (e) => {
    const btnLinkCheck =
      e.target.tagName === "BUTTON" || e.target.tagName === "A";
    const trigger = btnLinkCheck ? e.target : e.target.parentElement;
    const menu = trigger.nextElementSibling;

    if (menu) {
      // HAMBURGER CHILD MENU TOGGLE
      if (
        trigger.parentElement.classList.contains(
          "menu-item-object-ccs_custom_menu_item"
        )
      ) {
        e.preventDefault();
        if (!matchMedia("(min-width: 1200px)").matches) {
          if (!trigger.classList.contains("active")) {
            const hamburgerActives = [
              ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
            ];
            this.closeAll(hamburgerActives);
            trigger.classList.add("active");
            trigger.parentElement.classList.add("active");
            menu.classList.add("active");
            this.scrollHeader.classList.add("active");
            document.body.classList.add("lock-scroll");
            this.mainHeader.classList.add("bg-overwhite");
            this.hamburger.classList.add("sub-open");
          } else {
            trigger.classList.remove("active");
            trigger.parentElement.classList.remove("active");
            menu.classList.remove("active");
            this.scrollHeader.classList.remove("active");
            this.hamburger.classList.remove("sub-open");
          }
        } else if (!trigger.classList.contains("active")) {
          if (!matchMedia("(min-width: 1200px)").matches) {
            const hamburgerActives = [
              ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
            ];
            this.closeAll(hamburgerActives);
          }
          this.closeAll(this.all);

          trigger.classList.add("active");
          menu.classList.add("active");
          document.body.classList.add("lock-scroll");
          this.mainHeader.classList.add("bg-overwhite");
        } else {
          if (!matchMedia("(min-width: 1200px)").matches) {
            const hamburgerActives = [
              ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
            ];
            this.closeAll(hamburgerActives);
          }
          this.closeAll(this.all);
        }
      }

      // HAMBURGER PARENT MENU TOGGLE
      else if (trigger.classList.contains("btn-hamburger")) {
        if (!trigger.classList.contains("active")) {
          if (!matchMedia("(min-width: 1200px)").matches) {
            const hamburgerActives = [
              ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
            ];
            this.closeAll(hamburgerActives);
          }
          this.closeAll(this.all);

          trigger.classList.add("active");
          menu.classList.add("active");
          document.body.classList.add("lock-scroll");
          this.mainHeader.classList.add("bg-overwhite");
        } else {
          if (!matchMedia("(min-width: 1200px)").matches) {
            const hamburgerActives = [
              ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
            ];
            this.closeAll(hamburgerActives);
          }
          this.closeAll(this.all);
        }
      }

      // MEGA MENU TOGGLE
      else if (
        menu.classList.contains("mega-menu-wrapper") &&
        !menu.classList.contains("sub-menu")
      ) {
        if (!trigger.classList.contains("active")) {
          if (!matchMedia("(min-width: 1200px)").matches) {
            const hamburgerActives = [
              ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
            ];
            this.closeAll(hamburgerActives);
          }
          this.closeAll(this.all);

          trigger.classList.add("active");
          menu.classList.add("active");
          document.body.classList.add("lock-scroll");
          this.mainHeader.classList.add("bg-overwhite");
        } else {
          if (!matchMedia("(min-width: 1200px)").matches) {
            const hamburgerActives = [
              ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
            ];
            this.closeAll(hamburgerActives);
          }
          this.closeAll(this.all);
        }
      }
    }

    this.setGlobals();
  };

  this.megaMenu = new MegaMenu(
    this.mainHeader,
    this.all,
    this.closeAll,
    this.toggleMenu
  );

  this.mobileMenu = new MobileMenu(
    this.mainHeader,
    this.all,
    this.closeAll,
    this.toggleMenu,
    this.hamburger,
    this.scrollHeader
  );

  this.outsideClick = () => {
    document.addEventListener("click", (e) => {
      if (
        !this.mainHeader.contains(e.target) &&
        !this.cookieBar.contains(e.target)
      ) {
        if (!matchMedia("(min-width: 1200px)").matches) {
          const hamburgerActives = [
            ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
          ];
          this.closeAll(hamburgerActives);
        }
        this.closeAll(this.all);
      }
    });
  };

  this.checkPagePosition = () => {
    if (this.mainHeader.classList.contains("bg-transparent-header")) {
      return (
        this.mainHeader.getBoundingClientRect().top >
        this.page.getBoundingClientRect().top
      );
    }
    return (
      this.mainHeader.getBoundingClientRect().bottom >
      this.page.getBoundingClientRect().top
    );
  };

  this.scrollColorChange = () => {
    if (this.checkPagePosition()) {
      this.mainHeader.classList.add("bg-overwhite");
    } else {
      this.mainHeader.classList.remove("bg-overwhite");
    }
  };

  this.toggleSearch = (e) => {
    const btnLinkCheck =
      e.target.tagName === "BUTTON" || e.target.tagName === "A";
    const trigger = btnLinkCheck ? e.target : e.target.parentElement;

    if (!this.searchWrapper.classList.contains("active")) {
      if (!matchMedia("(min-width: 1200px)").matches) {
        const hamburgerActives = [
          ...this.hamburger.nextElementSibling.querySelectorAll(".active"),
        ];
        this.closeAll(hamburgerActives);
      }
      this.closeAll(this.all);

      document.body.classList.add("lock-scroll");
      this.mainHeader.classList.add("bg-overwhite");
      this.searchWrapper.classList.add("active");
      trigger.classList.add("active");
    } else {
      document.body.classList.remove("lock-scroll");
      this.mainHeader.classList.remove("bg-overwhite");
      this.searchWrapper.classList.remove("active");
      trigger.classList.remove("active");
    }

    const searchActionInput = this.mainHeader.querySelector(
      ".search-action input"
    );

    if (searchActionInput) {
      const focusTimeout = setTimeout(() => {
        searchActionInput.focus();
        clearTimeout(focusTimeout);
      }, 300);
    }
  };

  this.searchEvent = () => {
    this.searchButtons.forEach((searchButton) => {
      searchButton.addEventListener("click", (e) => {
        this.toggleSearch(e);
      });
    });
  };

  this.domInit = () => {
    this.setHeaderColor();
    this.setGlobals();
  };

  this.bindEvents = () => {
    this.domInit();
    this.mobileMenu.events();
    this.megaMenu.events();
    this.searchEvent();
    this.outsideClick();
  };

  this.init = () => {
    this.bindEvents();
    this.headerReady();
  };

  return this;
}

export default new Header();
